import styled from 'styled-components'

const PageTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-top: 30px;
`

export default PageTitle
